import { ISelectItem } from "@/types";
import { IMember } from "@/types/member";
import { ISales } from "@/types/sales";
import { IStatus } from "@/types/status";
import { ITag } from "@/types/tag";
import {
  ITicket,
  ITicketCreateRequest,
  ITicketListRequest,
  ITicketRequest,
  ITicketUpdateRequest,
} from "@/types/ticket";
import moment from "moment";
import { ListRequest } from "./listRequest";
import { Member } from "./member";
import { Sales } from "./sales";
import { Status } from "./status";
import { Tag } from "./tag";

export class Ticket implements ITicket {
  public id = 0;
  public sale_id = 0;
  public charge_id = 0;
  public member_id = 0;
  public company_id = 0;
  public status_id = 0;
  public subject = "";
  public memo = "";
  public deadline_at = "";
  public created_at = "";
  public updated_at = "";
  public tags: ITag[] = [];
  public sale: ISales = new Sales();
  public status: IStatus = new Status();
  public charge: ISales = new Sales();
  public members: IMember[] = [];

  public constructor(props?: ITicket) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    this.sale = new Sales(props.sale);
    this.status = new Status(props.status);
    this.charge = new Sales(props.charge);
    this.deadline_at = this.deadline_at
      ? moment(props.deadline_at).format("YYYY-MM-DD")
      : "";
    if (props.tags) {
      this.tags = props.tags.map((tag) => new Tag(tag));
    }
    if (props.members) {
      this.members = props.members.map((member) => new Member(member));
    }
  }

  public static toSelectItem(ticket: ITicket): ISelectItem {
    return {
      text: ticket.subject,
      value: ticket.id,
    };
  }
}

export class TicketRequest implements ITicketRequest {
  public subject = "";
  public memo = "";
  public deadline_at = "";
  public sale_id = 0;
  public status_id = 0;
  public charge_id = 0;
  public members: number[] = [];
  public tags: number[] = [];
  [key: string]: unknown;
}

export class TicketCreateRequest
  extends TicketRequest
  implements ITicketCreateRequest {}

export class TicketUpdateRequest
  extends TicketRequest
  implements ITicketUpdateRequest
{
  public constructor(props?: ITicket) {
    super();

    if (!props) {
      return;
    }
    Object.assign(this, props);
    this.deadline_at = this.deadline_at
      ? moment(props.deadline_at).format("YYYY-MM-DD")
      : "";
    this.members = props.members.map((item) => item.id);
    this.tags = props.tags.map((item) => item.id);
  }
}

export class TicketListRequest
  extends ListRequest
  implements ITicketListRequest
{
  status = 0;
  inprogress = true;
}
